"use client";

import * as React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @deprecated use Clock icon from "@faire/web/slate/icons/foundation/Clock" instead
 * @optimized using svgo:^3.0.2
 */
export const Clock = createSVGIcon(
  <>
    <path
      clipRule="evenodd"
      d="M8.5 16a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15z"
      stroke="currentColor"
    />
    <rect x="8" y="3" width="1" height="6" rx=".5" fill="currentColor" />
    <rect
      x="11.846"
      y="10.305"
      width="1"
      height="4"
      rx=".5"
      transform="rotate(125.181 11.846 10.305)"
      fill="currentColor"
    />
  </>,
  "Clock",
  { viewBox: "0 0 17 17", fill: "none" }
);
